import $ from 'jquery'
import _ from 'lodash'

type ConsoleMethods = 'debug' | 'info' | 'log' | 'warn' | 'error' | 'trace'
type ConsoleLogMap = {
  [key in ConsoleMethods]: (...args: unknown[]) => void
}

window.addEventListener(
  'DOMContentLoaded',
  () => {
    if ($('body').data('environment') !== 'production') {
      // eslint-disable-next-line no-console
      console.warn('- console.(debug|info|log|warn|error) monkey-patched')
    }
  },
  { once: true }
)
$(document).on('turbolinks:load', () => {
  const methods: ConsoleMethods[] = [
    'debug',
    'info',
    'log',
    'warn',
    'error',
    'trace',
  ]

  // We have to take the direct references to the actual function like this
  // instead of doing just: originalConsole = console
  const originalConsole = _.reduce(
    methods,
    (memo, methodName) => {
      // eslint-disable-next-line no-console
      memo[methodName] = _.bind(console[methodName], console)
      return memo
    },
    {} as ConsoleLogMap
  )

  const patchedConsole = _.reduce(
    methods,
    (memo, methodName) => {
      memo[methodName] = function (...args): void {
        // Logging to Sentry when console.log JQMigrate message
        if (args[0] && _.isString(args[0])) {
          if (args[0].includes('JQMigrate')) {
            if (window.Sentry) {
              window.Sentry.captureMessage(`JQMigrate issue: ${args[0]}`, {
                level: 'warning',
              })
            }
          }
        }

        originalConsole[methodName].apply(this, args)
      }

      return memo
    },
    {} as ConsoleLogMap
  )

  const methodKeys = Object.keys(patchedConsole) as ConsoleMethods[]

  // Apply monkey-patch to global.console
  methodKeys.forEach((methodName: ConsoleMethods): void => {
    // eslint-disable-next-line no-console
    window.console[methodName] = patchedConsole[methodName]
  })
})
